const gcp = "AIzaSyAbFQh0nFL_-bV68W2Y-nZhQ1Z64g5LzfQ";
export default gcp;
